export enum UserProvisioningMode {
    Undefined = 0,
    UserOnly = 1,
    UserAndContact = 2
}
